export default __webpack_public_path__ + "static/media/acros-trio-b&w.08430d90.jpg";